import { createRouter, createWebHistory } from 'vue-router'
import './meta'
import { authRoutes } from './routes/auth.routes'
import { anchorRoutes } from './routes/anchor.routes'
import { supplierRoutes } from './routes/supplier.routes'
import { opsRoutes } from './routes/ops.routes'
import { installGuards } from './guards'

export function createAppRouter() {
  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    // workspace routes first so the catch-all in authRoutes stays last
    routes: [...anchorRoutes, ...supplierRoutes, ...opsRoutes, ...authRoutes],
    scrollBehavior: (to, _from, saved) => saved ?? (to.hash ? { el: to.hash } : { top: 0 }),
  })
  installGuards(router)
  return router
}
